import { React, classNames } from '@digsup/core-ui';
import { PropTypes } from 'prop-types';
import { styles } from './FieldSet.scss';

const cx = classNames.bind(styles);

const FieldSet = ({ children, className }) => {
  const classes = cx('c-form-field-set', className);
  return <fieldset className={classes}>{children}</fieldset>;
};

FieldSet.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

FieldSet.defaultProps = {};

export { FieldSet };
